
function f1() {
    let lis = document.querySelectorAll(".pc .block-3 ul li"); //获取到所有的小li
    let imgs = document.querySelectorAll(".pc .block-3 .intro-images img"); //获取到所有的图片
    let j = -1;
    for (let i = 0; i < lis.length; i++) {
        lis[i].onmouseover = function () {
            j = i;
            for (let i = 0; i < lis.length; i++) {
                lis[i].className = "";
                imgs[i].style.display = "none"; //清空img
            }
            //给点击的li和对应的img设置样式
            this.className = "current";
            imgs[i].style.display = "block"
            lis[j].className = "active";
        }
    }
}

function f2() {
    var oDiv = document.getElementById('div1');
    var oUl = oDiv.getElementsByTagName('ul')[0];
    var aLi = oUl.getElementsByTagName('li');
    var iSpeed = 1;//正左负右
    //计算ul的宽为所有li的宽的和;
    oUl.innerHTML += oUl.innerHTML + oUl.innerHTML;
    oUl.style.width = aLi[0].offsetWidth * aLi.length + 'px';

    function Slider() {
        if (oUl.offsetLeft < -oUl.offsetWidth / 2) {
            oUl.style.left = 0;
        } else if (oUl.offsetLeft > 0) {
            oUl.style.left = -oUl.offsetWidth / 2 + 'px';
        }
        oUl.style.left = oUl.offsetLeft - iSpeed + 'px';//正负为方向
    }

    setInterval(Slider, 30);
}

function f9(){
    var oDiv = document.getElementById('div9');
    var oUl = oDiv.getElementsByTagName('ul')[0];
    var aLi = oUl.getElementsByTagName('li');
    var iSpeed = 1;//正左负右
    //计算ul的宽为所有li的宽的和;
    oUl.innerHTML += oUl.innerHTML + oUl.innerHTML;
    oUl.style.width = aLi[0].offsetWidth * aLi.length + 'px';

    function Slider() {
        if (oUl.offsetLeft < -oUl.offsetWidth / 2) {
            oUl.style.left = 0;
        } else if (oUl.offsetLeft > 0) {
            oUl.style.left = -oUl.offsetWidth / 2 + 'px';
        }
        oUl.style.left = oUl.offsetLeft - iSpeed + 'px';//正负为方向
    }

    setInterval(Slider, 60);
}

window.onload = function () {
    f1();
    f2();
    f9();

}